import React, { useEffect } from 'react'
import MainLayout from '../layouts/MainLayout'
import { useDispatch, useSelector } from 'react-redux'
import { getPostById } from '../redux/actions/post'
import { useParams } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { Helmet } from 'react-helmet-async'

const PostDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { post } = useSelector((state: any) => state.posts);
  useEffect(() => {
    if (id) {
      dispatch<any>(getPostById(id));
    }
  }, [id]);

  const breadcrumbItems = [
    {
      title: 'Anasayfa',
      href: '/',
    },
    {
      title: 'Blog',
      href: '/blog',
    },
    {
      title: post?.title || 'Blog Yazısı',
      href: `/blog/${post?.slug || post?._id}`,
    },
  ];

  return (
    <MainLayout>
      <Helmet>
        <title>{post?.title ? `${post.title} | Blog` : 'Blog Yazısı | Blog'}</title>
        <meta name="description" content={post?.description || 'Blog yazısı detay sayfası'} />
        <meta property="og:title" content={post?.title ? `${post.title} | Blog` : 'Blog Yazısı | Blog'} />
        <meta property="og:description" content={post?.description || 'Blog yazısı detay sayfası'} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`${window.location.origin}/blog/${post?.slug || post?._id || ''}`} />
        {post?.headerImage && (
          <meta property="og:image" content={`${post.headerImage.replace(/\.(png|jpg|jpeg|gif)$/i, '.webp')}`} />
        )}
      </Helmet>
      <div className='container mx-auto'>
        <div className='flex w-full bg-gray-50 p-3 border rounded-md'>
          <Breadcrumb items={breadcrumbItems} />
        </div>
        <h1 className="text-4xl font-bold mb-6 text-gray-800 my-5">
          {post?.title || 'Blog Yazısı'}
        </h1>
        {post?.headerImage && (
          <div className="w-full h-[141px] overflow-hidden rounded-lg mb-8">
            <img
              src={`${post.headerImage.replace(/\.(png|jpg|jpeg|gif)$/i, '.webp')}`}
              alt={post?.title || 'Blog yazısı görseli'}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <div className="max-w-4xl mx-auto px-4 py-8">
          {/* Author and Date */}
          <div className="flex items-center gap-4 mb-8 text-gray-600">
            <span className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
              </svg>
              {post?.user || 'Anonim'}
            </span>
            <span className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
              </svg>
              {post?.date ? new Date(post.date).toLocaleDateString('tr-TR') : 'Tarih belirtilmemiş'}
            </span>
          </div>

          {/* Blog Image */}
          {post?.blogImage && (
            <div className="w-full h-[300px] overflow-hidden rounded-lg mb-8">
              <img
                src={`${post.blogImage}`}
                alt={post?.title || 'Blog yazısı görseli'}
                className="w-full h-full object-cover"
              />
            </div>
          )}

          {/* Description */}
          <div
            className="prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: post?.description || 'İçerik yükleniyor...' }}
          />
        </div>
      </div>
    </MainLayout>
  )
}

export default PostDetail;